import { ComponentType } from 'react';

import { Link } from '@northladder/i18n';

export interface ILinkActionProps {
  href: string;
  IconStart: ComponentType<{ className?: string }>;
  text: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a link action with a start icon and text
 */
export function LinkAction({
  href,
  IconStart,
  text,
}: Readonly<ILinkActionProps>) {
  return (
    <Link
      className="
        flex items-center gap-1 border-b border-b-gray-300 pb-1
        text-xs text-green-800
      "
      href={href}
    >
      <IconStart />
      <div>{text}</div>
    </Link>
  );
}
